module.exports = __webpack_public_path__ + "static/media/v8m.43e46a2b.mp4";